export const BALL_RADIUS = 24;
export const GRAVITY = 0.5;
export const JUMP_VELOCITY = -14;
export const COLORS = {
  sky: 0x87CEEB,
  skyGradientTop: 0xADD8E6,
  skyGradientBottom: 0x87CEEB,
  ball: 0xFF6B6B,
  ballHighlight: 0xFF9999,
  ground: 0xFFD93D,
  groundDark: 0xE5C235,
  accent: 0xFFD93D,
  secondary: 0x8B7355,
  background: 0xFFF8E7,
  shadow: 0x00000022,
  white: 0xFFFFFF,
} as const;
export const SCORE_INTERVAL_MS = 1000;
export const STORAGE_KEY = 'keepTheBallUp_bestScore';
export const GAME_STATES = {
  LOBBY: 'lobby',
  HOW_TO_PLAY: 'how_to_play',
  PLAYING: 'playing',
  GAME_OVER: 'game_over',
} as const;
export type GameState = (typeof GAME_STATES)[keyof typeof GAME_STATES];
export const UI_COLORS = {
  primary: '#FFD93D',
  primaryHover: '#E5C235',
  secondary: '#8B7355',
  background: '#FFF8E7',
  surface: '#FFFFFF',
  text: '#2D2A26',
  textMuted: '#7A756E',
  shadowLight: 'rgba(139, 115, 85, 0.15)',
  shadowDark: 'rgba(139, 115, 85, 0.25)',
} as const;